import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Pakistani CNIC validator following Single Responsibility Principle
 */
export class PkValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Pakistani CNIC',
      pattern: /^\d{5}-?\d{7}-?\d$/,
      length: 13
    });
  }

  validateFormat(id) {
    const cleanId = id.replace(/-/g, '');
    
    // Check length
    const lengthValidation = this.validateLength(cleanId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Pakistani CNIC format must be XXXXX-XXXXXXX-X'
    );
  }

  validateChecksum(id) {
    const cleanId = id.replace(/-/g, '');
    
    // CNIC uses a specific algorithm
    const weights = [6, 5, 4, 3, 2, 7, 6, 5, 4, 3, 2, 7];
    let sum = 0;

    for (let i = 0; i < 12; i++) {
      sum += parseInt(cleanId[i]) * weights[i];
    }

    const remainder = sum % 11;
    let expectedChecksum;
    
    if (remainder < 2) {
      expectedChecksum = remainder;
    } else {
      expectedChecksum = 11 - remainder;
    }

    const actualChecksum = parseInt(cleanId[12]);
    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid Pakistani CNIC checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid Pakistani CNIC');
  }
}